var _a, _b;
import { __assign } from "tslib";
import { reduxKey } from './constants';
import { setWatchingState, clickWatch, requestFailure, requestSuccess, } from './actionCreators';
import { handleActions } from 'redux-actions';
function setUserState(state, username, value) {
    var _a;
    if (!username) {
        return state;
    }
    var normalizedUsername = username.toLowerCase();
    return __assign(__assign({}, state), (_a = {}, _a[normalizedUsername] = __assign(__assign({}, state[normalizedUsername]), value), _a));
}
var actionHandlers = handleActions((_a = {},
    _a[clickWatch.toString()] = function (state, _a) {
        var username = _a.payload.user.username;
        return setUserState(state, username, {
            isLoading: true,
        });
    },
    _a[requestFailure.toString()] = function (state, _a) {
        var username = _a.payload.username;
        return setUserState(state, username, {
            isLoading: false,
        });
    },
    _a[requestSuccess.toString()] = function (state, _a) {
        var _b = _a.payload, username = _b.username, isWatching = _b.isWatching;
        return setUserState(state, username, {
            isLoading: false,
            isWatching: isWatching,
        });
    },
    _a[setWatchingState.toString()] = function (state, _a) {
        var _b = _a.payload, username = _b.username, isWatching = _b.isWatching;
        return setUserState(state, username, {
            isLoading: false,
            isWatching: isWatching,
        });
    },
    _a), {});
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducers.js.map